module.exports = __webpack_public_path__ + "media/newstyle/images/stars_4-orange-bba855689ff24b25e85000663599cb30.svg";